import { trans } from '@spotahome/soyuz/client';
import PropTypes from 'prop-types';

import VerificationInfo from '../../VerificationInfo';
import Button from '../../Button';
import { HomeCheckerShape } from '../../../shapes/HomeChecker';

const CheckedDescription = ({
  homechecker = {},
  verificationDate = '',
  onMoreDetailsClick = () => {},
  showButtonModal = false
}) => {
  return (
    <div>
      {homechecker?.firstName ? (
        <span>{trans('listing.labels.checked.description')}</span>
      ) : (
        <span>{trans('listing.verification.team_message')}</span>
      )}
      {showButtonModal ? (
        <Button color="link" onClick={onMoreDetailsClick}>
          {trans('listing.verification.more-button')}
        </Button>
      ) : (
        <VerificationInfo
          homechecker={homechecker}
          verificationDate={verificationDate}
          transparent
          className="verification-info__homechecker--checked"
        />
      )}
    </div>
  );
};

CheckedDescription.propTypes = {
  homechecker: PropTypes.shape(HomeCheckerShape),
  verificationDate: PropTypes.string,
  onMoreDetailsClick: PropTypes.func,
  showButtonModal: PropTypes.bool
};

export default CheckedDescription;
